import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { AtividadeChecklistItemComponent } from './atividade-checklist-item.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        AtividadeChecklistItemComponent
    ],
    exports: [
        AtividadeChecklistItemComponent
    ]
})
export class AtividadeChecklistItemModule { }
